import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    "en": '',
  },
});

function setI18nLanguage (lang) {
  i18n.locale = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

export function loadLanguageAsync (lang) {
  i18n.setLocaleMessage(lang, languages[lang]);
  return setI18nLanguage(lang);
}

const languages = {
  'en': {
    "Filter documents": "Filter documents by title",
    "Filter results": "Filter results",
    "Start date": "Start date",
    "End date": "End date",
    "All departments": "All departments",
    "Clear filters": "Clear filters",
    "Title": "Title",
    "Publish date": "Publish Date",
    "Department": "Department",
    "Previous": "Previous",
    "Next": "Next",
    "No results": "Sorry, there are no results.",
    "There was a problem": "Sorry, there was a problem. Please try again.",
  },
  'es': {
    "Filter documents": "Filtrar documentos por título",
    "Filter results": "Filtrar resultados",
    "Start date": "Fecha de inicio",
    "End date": "Fecha de finalización",
    "All departments": "Todos los departamentos",
    "Clear filters": "Borrar filtros",
    "Title": "Título",
    "Publish date": "Fecha de publicación",
    "Department": "Departamento",
    "Previous": "Anterior",
    "Next": "Próximo",
    "No results": "Lo sentimos, no hay resultados.",
    "There was a problem": "Lo siento, ha habido un problema. Por favor, inténtalo de nuevo.",
  },
  'zh': {
    "Filter documents": "按标题筛选文档",
    "Filter results": "筛选结果",
    "Start date": "开始日期",
    "End date": "结束日期",
    "All departments": "所有部门",
    "Clear filters": "清除筛选条件",
    "Title": "标题",
    "Publish date": "发布日期",
    "Department": "部门",
    "Previous": "以前",
    "Next": "下一步",
    "No results": "抱歉，没有结果。",
    "There was a problem": "抱歉，出现了一个问题。请再试一次。",
  },
  'ar': {
    "Filter documents": "تصفية المستندات حسب العنوان",
    "Filter results": "تصفية النتائج",
    "Start date": "تاريخ البدء",
    "End date": "تاريخ النهاية",
    "All departments": "جميع الأقسام",
    "Clear filters": "مسح جميع الفلاتر",
    "Title": "عنوان",
    "Publish date": "تاريخ النشر",
    "Department": "قسم",
    "Previous": "السابق",
    "Next": "التالي",
    "No results": "عذرًا، لا توجد نتائج",
    "There was a problem": "آسف، كانت هناك مشكلة. يرجى المحاولة مرة أخرى",
  },
  'ht': {
    "Filter documents": "Filtre dokiman pa tit",
    "Filter results": "Rezilta filtre",
    "Start date": "Kòmanse dat",
    "End date": "Dat fen",
    "All departments": "Tout depatman",
    "Clear filters": "Clear filters",
    "Title": "Tit",
    "Publish date": "Pibliye dat",
    "Department": "Depatman",
    "Previous": "Anvan",
    "Next": "Pwochen",
    "No results": "Padon, pa gen okenn rezilta.",
    "There was a problem": "Padon, te gen yon pwoblèm. Tanpri eseye ankò.",
  },
  'fr': {
    "Filter documents": "Filtrer les documents par titre",
    "Filter results": "Filtrer les résultats",
    "Start date": "Date de début",
    "End date": "Date de fin",
    "All departments": "All departments",
    "Clear filters": "Effacer les filtres",
    "Title": "Titre",
    "Publish date": "Date de publication",
    "Department": "Département",
    "Previous": "Précédent",
    "Next": "Suivant",
    "No results": "Désolé, il n'y a aucun résultat.",
    "There was a problem": "Désolé, un problème est survenu. Veuillez réessayer.",
  },
  'sw': {
    "Filter documents": "Chuja nyaraka kwa kichwa",
    "Filter results": "Matokeo ya kuchuja",
    "Start date": "Tarehe ya kuanza",
    "End date": "Tarehe ya mwisho",
    "All departments": "Idara zote",
    "Clear filters": "Futa vichungi",
    "Title": "Kichwa",
    "Publish date": "Chapisha tarehe",
    "Department": "Idara",
    "Previous": "Iliyotangulia",
    "Next": "Ifuatayo",
    "No results": "Samahani, hakuna matokeo.",
    "There was a problem": "Samahani, kulikuwa na tatizo. Tafadhali jaribu tena.",
  },
  'pt': {
    "Filter documents": "Filtrar documentos por título",
    "Filter results": "Filtrar resultados",
    "Start date": "Data de início",
    "End date": "Data de término",
    "All departments": "Todos os departamentos",
    "Clear filters": "Filtros claros",
    "Title": "Título",
    "Publish date": "Data de publicação",
    "Department": "Departamento",
    "Previous": "Anterior",
    "Next": "Próximo",
    "No results": "Desculpe, não há resultados.",
    "There was a problem": "Desculpe, houve um problema. Por favor, tente novamente.",
  },
  'ru': {
    "Filter documents": "Фильтрация документов по заголовку",
    "Filter results": "Отфильтровать результаты",
    "Start date": "Дата начала",
    "End date": "Дата окончания",
    "All departments": "Все отделы",
    "Clear filters": "Очистить фильтры",
    "Title": "Заголовок",
    "Publish date": "Дата публикации",
    "Department": "Департамент",
    "Previous": "предыдущий",
    "Next": "Следующий",
    "No results": "Извините, результатов нет.",
    "There was a problem": "Извините, возникла проблема. Пожалуйста, попробуйте еще раз.",
  },
  'vi': {
    "Filter documents": "Lọc tài liệu theo tiêu đề",
    "Filter results": "Lọc kết quả",
    "Start date": "Ngày bắt đầu",
    "End date": "Ngày kết thúc",
    "All departments": "Tất cả các phòng ban",
    "Clear filters": "Xóa bộ lọc",
    "Title": "Tiêu đề",
    "Publish date": "Ngày xuất bản",
    "Department": "Sở",
    "Previous": "Trước",
    "Next": "Tiếp",
    "No results": "Xin lỗi, không có kết quả.",
    "There was a problem": "Xin lỗi, có một vấn đề. Vui lòng thử lại.",
  },
};
